"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reverseHashMap = exports.values = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const values = obj => Object.keys(obj).map(key => obj[key]);
exports.values = values;
function reverseHashMap(obj1, obj2) {
  return Object.keys(obj1).reduce((prev, key) => {
    prev[obj1[key]] = obj2[key];
    return prev;
  }, {});
}
exports.reverseHashMap = reverseHashMap;